<ng-template #content_b2b_account let-offcanvas>
    <div class="{{localService.selectedLanguageCode}}"
        *ngIf="localService.languageContent && localService.languageContent.b2b">
        <div class="side_popup_header">
            <span>{{localService.languageContent.b2b.popup_title}}</span>
            <button class="button_icon" (click)="onCloseTrigger()">close</button>
        </div>
        <div class="side_popup_body" style="padding: 10px;"
            [ngStyle]="{'max-height' : localService.sideBarBodyHeight + 'px'}">
            <div class="row">
                <div class="col-12">
                    <div>
                        <app-label [Text]="localService.languageContent.b2b.acct_name" [IsMandatory]="true" />
                    </div>
                    <div>
                        <input autocomplete="off" type="text" style="margin-bottom: 10px;" [(ngModel)]="data.v2"
                            title="{{localService.languageContent.b2b.acct_name}}"
                            placeholder="{{localService.languageContent.b2b.acct_name}}" />
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <div>
                        <app-label [Text]="localService.languageContent.b2b.tax_id" [IsMandatory]="true" />
                    </div>
                    <div>
                        <input autocomplete="off" type="text" style="margin-bottom: 10px;" [(ngModel)]="data.v3"
                            title="{{localService.languageContent.b2b.tax_id}}"
                            placeholder="{{localService.languageContent.b2b.tax_id}}" />
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <div>
                        <app-label [Text]="localService.languageContent.b2b.address" [IsMandatory]="true" />
                    </div>
                    <div>
                        <textarea autocomplete="off" rows="5" style="margin-bottom: 10px;" [(ngModel)]="data.v1"
                            title="{{localService.languageContent.b2b.address}}"
                            placeholder="{{localService.languageContent.b2b.address}}">
                        </textarea>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <div>
                        <app-label [Text]="localService.languageContent.b2b.contact_nbr" />
                    </div>
                    <div>
                        <input autocomplete="off" type="text" style="margin-bottom: 10px;" [(ngModel)]="data.v4"
                            title="{{localService.languageContent.b2b.contact_nbr}}"
                            placeholder="{{localService.languageContent.b2b.contact_nbr}}" />
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <div>
                        <app-label [Text]="localService.languageContent.b2b.email" />
                    </div>
                    <div>
                        <input autocomplete="off" type="text" style="margin-bottom: 10px;" [(ngModel)]="data.v5"
                            title="{{localService.languageContent.b2b.email}}"
                            placeholder="{{localService.languageContent.b2b.email}}" />
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <div>
                        <app-label [Text]="localService.languageContent.b2b.website" />
                    </div>
                    <div>
                        <input autocomplete="off" type="text" style="margin-bottom: 10px;" [(ngModel)]="data.v6"
                            title="{{localService.languageContent.b2b.website}}"
                            placeholder="{{localService.languageContent.b2b.website}}" />
                    </div>
                </div>
            </div>
            <div class="row" *ngIf="b2bAccountId && b2bAccountId.length > 5">
                <div class="col-12">
                    <label style="font-weight: normal;margin-left: 30px;">
                        <input type="checkbox" [(ngModel)]="data.isSelected" />
                        <span class="normal_color">{{localService.languageContent.common.is_active}}</span>
                    </label>
                </div>
            </div>
        </div>
        <div class="side_popup_footer">
            <div class="row">
                <div class="col-12" style="text-align: right;">
                    <button id="{{elementIds.save}}" type="button" class="btn btn-primary" (click)="onAction(1)">
                        {{b2bAccountId && b2bAccountId.length > 5
                        ? localService.languageContent.common.save
                        : localService.languageContent.common.create}}
                    </button>
                </div>
            </div>
        </div>
    </div>
</ng-template>